import { render, staticRenderFns } from "./RcclNewsDetail.vue?vue&type=template&id=0760f39c&scoped=true"
import script from "./RcclNewsDetail.vue?vue&type=script&lang=js"
export * from "./RcclNewsDetail.vue?vue&type=script&lang=js"
import style0 from "./RcclNewsDetail.vue?vue&type=style&index=0&id=0760f39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0760f39c",
  null
  
)

export default component.exports